
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-publicaciones-ml/pc/lista/controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get ReservarAltura() { return this.Controlador.Vista.BarraArriba.Altura.Espacio; }
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            document.getElementById( 'lista-publicaciones' ).addEventListener( 'scroll', this.onScroll );
        }

        onScroll( ele: any )
        {

            let cc = ele.target.offsetHeight + ele.target.scrollTop - ele.target.scrollHeight;
            if ( ele.target.scrollTop > 60 && !this.Controlador.Vista.BarraArriba.AbiertoManual )
            {
                this.Controlador.Vista.BarraArriba.Abierto = false;
            }

            if ( cc > -10 && !this.CargandoMas )
            {
                this.BuscarMas();
            }

        }


        public CargandoMenu: boolean = false;
        public Opciones = [

            {
                Tipo: 'opcion', Titulo: 'Abrir en MercadoLibre', Accion: async ( item: Publicacion ) =>
                {

                    window.open( item.Link );
                },
                Ok: ( item: Publicacion ) => true
            },

            { Tipo: 'titulo', Titulo: 'Acciones' },
            {
                Tipo: 'opcion', Titulo: 'Pausar', Accion: async ( item: Publicacion ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await item.Pausar();
                    if ( pdf )
                    {
                        Utiles.Notificaciones.Completado( `Publicación pausada` );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al modificar la publicacion` );
                    }
                    this.CargandoMenu = false;
                },
                Ok: ( item: Publicacion ) => !item.Estado.esPausada
            },

            {
                Tipo: 'opcion', Titulo: 'Activar', Accion: async ( item: Publicacion ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await item.Activar();
                    if ( pdf )
                    {
                        Utiles.Notificaciones.Completado( `Publicación activada` );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al modificar la publicacion` );
                    }
                    this.CargandoMenu = false;
                },
                Ok: ( item: Publicacion ) => !item.Estado.esActiva
            },

            {
                Tipo: 'opcion', Titulo: 'Cerrar', Accion: async ( item: Publicacion ) =>
                {

                    this.CargandoMenu = true;
                    let pdf = await item.Cerrar();
                    if ( pdf )
                    {
                        Utiles.Notificaciones.Completado( `Publicación cerrada` );
                    } else
                    {
                        Utiles.Notificaciones.Error( `Error al modificar la publicacion` );
                    }
                    this.CargandoMenu = false;
                },
                Ok: ( item: Publicacion ) => !item.Estado.esCerrada
            },
        ];

        Abrir( item: Publicacion )
        {
            this.Controlador.Abrir( item );
        }

        public CargandoMas: boolean = false;
        async BuscarMas()
        {
            if ( this.Buscador.Paginacion && !this.Buscador.Paginacion.Final )
            {
                this.CargandoMas = true;
                await this.Buscador.Buscar( this.Buscador.Paginacion.Pagina + 1, true );
                this.CargandoMas = false;
            }

        }
    }
